<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<!-- Optional navbar at top of page -->
				<div id="navbar" class="navbar navbar-expand-lg flex-nowrap box-shadow">
					<!-- Page title -->
					<div class="navbar-text nav-title flex" id="pageTitle">Pending Users</div>

					<!-- Show inactive -->
					<div class="checkbox mr-3">
						<label class="md-check">
							<input v-model="showHistory" type="checkbox" />
							<i class="theme-accent"></i>
							Show History
						</label>
					</div>

					<!-- Search field -->
					<div class="collapse navbar-collapse no-grow order-lg-1" id="navbarToggler">
						<form class="input-group m-2 my-lg-0">
							<span class="input-group-btn">
								<button type="button" class="btn no-border no-bg no-shadow">
									<i class="fa fa-search"></i>
								</button>
							</span>
							<input type="text" v-model="filter" class="form-control" placeholder="Search users..." />
						</form>
					</div>
				</div>

				<!-- Page Content -->
				<div class="content-main">
					<div class>
						<!-- Page content goes here -->
						<b-table
							ref="table"
							responsive="lg"
							striped
							hover
							:show-empty="true"
							:items="provider"
							:fields="fields"
							:current-page="currentPage"
							:per-page="perPage"
							:filter="filter"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
						>
							<!-- Name Virtual Column -->
							<template slot="name" slot-scope="data"
								>{{ data.item.first_name }} {{ data.item.last_name }}</template
							>

							<!-- Role -->
							<template slot="role" slot-scope="data">{{
								data.item.role ? data.item.role.name : "???"
							}}</template>

							<!-- District -->
							<template slot="district" slot-scope="data">{{
								data.item.district ? data.item.district.name : "???"
							}}</template>

							<!-- Team -->
							<template slot="team" slot-scope="data">
								<span v-if="!data.item.team" class="text-extra-muted">None</span>
								<span v-if="data.item.team">{{ data.item.team.name }}</span>
							</template>

							<!-- Content Area -->
							<template slot="content_area" slot-scope="data">
								<span v-if="data.item.content_areas.length == 0" class="text-extra-muted">None</span>
								<span v-if="data.item.content_areas.length == 1">{{
									data.item.content_areas[0].name
								}}</span>
								<span
									v-if="data.item.content_areas.length > 1"
									v-tippy
									:title="listNames(data.item.content_areas, 'Content Areas')"
								>
									<i class="fas fa-chalkboard faw"></i>
									{{ data.item.content_areas.length }}
								</span>
							</template>

							<!-- Status -->
							<template slot="status" slot-scope="data">
								<div :class="{ [getStatusClass(data.item)]: true }">{{ getStatus(data.item) }}</div>
							</template>

							<!-- Registered -->
							<template slot="created_at" slot-scope="data">{{
								fs.medDate(data.item.created_at)
							}}</template>

							<!-- Actions -->
							<template slot="actions" slot-scope="data">
								<div class="mx-auto w60">
									<button
										v-if="canDeny(data.item) && !data.item.denying"
										@click="deny(data.item)"
										class="btn btn-sm btn-icon btn-rounded btn-danger text-white m-0"
										v-tippy
										title="Deny"
									>
										<i class="far fa-times"></i>
									</button>
									<button
										v-if="canDeny(data.item) && data.item.denying"
										class="btn btn-sm btn-icon btn-rounded btn-danger text-white m-0"
										v-tippy
										title="Denying..."
										disabled
									>
										<loading type="icon" />
									</button>

									<button
										v-if="canApprove(data.item) && !data.item.approving"
										@click="approve(data.item)"
										class="btn btn-sm btn-icon btn-rounded btn-success text-white m-0"
										v-tippy
										title="Approve"
									>
										<i class="far fa-check"></i>
									</button>
									<button
										v-if="canApprove(data.item) && data.item.approving"
										class="btn btn-sm btn-icon btn-rounded btn-success text-white m-0"
										v-tippy
										title="Approving..."
										disabled
									>
										<loading type="icon" />
									</button>

									<button
										v-if="canLink(data.item) && !data.item.linking"
										@click="goToUser(data.item)"
										class="btn btn-sm btn-icon btn-rounded theme-accent text-white m-0"
										v-tippy
										title="Go To User"
									>
										<i class="far fa-user"></i>
									</button>
									<button
										v-if="canLink(data.item) && data.item.linking"
										class="btn btn-sm btn-icon btn-rounded theme-accent text-white m-0"
										disabled
									>
										<loading type="icon" />
									</button>
								</div>
							</template>

							<template slot="empty">
								<loading type="table" v-if="loading" />
								<div v-if="!loading">There are no records to show</div>
							</template>
						</b-table>
					</div>
				</div>

				<div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
					<a class="flex mx-3">
						Page {{ totalRows > 0 ? currentPage : 0 }} of {{ Math.ceil(totalRows / perPage) }} ({{
							totalRows
						}})
					</a>
					<div>
						<b-pagination
							size="md"
							class="m-1"
							:total-rows="totalRows"
							v-model="currentPage"
							:per-page="perPage"
						></b-pagination>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w30 {
	width: 30px;
}
.w40 {
	width: 40px;
}
.w60 {
	width: 62px;
	text-align: center;
}
table,
td,
th {
	border: 1px solid lightgray;
}
</style>

<script>
//UI Components

//Libraries
import _ from "lodash";

//Services
import PendingUserService from "@/services/PendingUserService";
import UserService from "@/services/UserService";
import DistrictService from "@/services/DistrictService";
import SchoolService from "@/services/SchoolService";
import ContentAreaService from "@/services/ContentAreaService";
import ViewportService from "@/services/ViewportService";
import ThemeService from "@/services/ThemeService";
import store from "@/services/Store";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";

const headerHeight = 120;
const footerHeight = 96;

export default {
	name: "UserSetup",

	props: ["user"],

	data() {
		return {
			fs: fs,
			fields: [
				{ key: "name", sortable: true },
				{ key: "email", sortable: true },
				{ key: "district", sortable: true },
				{ key: "team", sortable: true },
				{
					key: "content_area",
					label: "Content Area(s)",
					sortable: true
				},
				{ key: "role", sortable: true },
				{ key: "status" },
				{ key: "created_at", label: "Registered", sortable: true },
				{
					key: "actions",
					label: "Actions",
					thStyle: { "text-align": "center" },
					tdClass: "p-custom p-0 v-mid"
				}
			],
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			filter: "",
			sortBy: null,
			sortDesc: false,
			showHistory: true,
			loading: true,

			roleNames: {},
			districtNames: {},
			schoolName: {},
			contentAreas: [],
			contentAreaMap: {},

			themeColor: null
		};
	},

	components: {},

	created() {
		this.themeColor = ThemeService.getThemeColor();

		this.sortBy = store.get(this, "pusers.sortBy");
		this.sortDesc = store.getDefault(this, "pusers.sortDesc", false);
		this.showArchived = store.getDefault(this, "pusers.showHistory", true);
	},

	destroyed() {
		window.removeEventListener("resize", this.resizeFunc);
	},

	watch: {
		sortBy() {
			store.set(this, "pusers.sortBy", this.sortBy);
		},
		sortDesc() {
			store.set(this, "pusers.sortDesc", this.sortDesc);
		},
		showHistory() {
			store.set(this, "pusers.showHistory", this.showHistory);
			this.refreshTable();
		}
	},

	methods: {
		provider(ctx) {
			ctx.active = this.showHistory;
			return BB.props({
				users: PendingUserService.listPendingUsersPrefilled(ctx),
				areas: ContentAreaService.listContentAreas()
			})
				.then(resps => {
					let users = resps.users.data.pendingUsers;
					this.totalRows = resps.users.data.totalRows;

					//Postload content areas on users
					this.contentAreas = resps.areas.data.content_areas;
					_.each(this.contentAreas, area => {
						this.contentAreaMap[area.id] = area;
					});

					_.each(users, user => {
						let areas = [];
						_.each(user.content_area_ids, caid => {
							let area = this.contentAreaMap[caid];
							if (area) {
								areas.push(area);
							}
						});

						user.content_areas = areas;
					});

					return users;
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to load pending users", err);
					return [];
				})
				.finally(() => {
					this.loading = false;
				});
		},

		canDeny(user) {
			return !user.decided;
		},

		canApprove(user) {
			return !user.decided || !user.approved;
		},

		canLink(user) {
			return user.user_id;
		},

		approve(user) {
			this.$set(user, "approving", true);
			PendingUserService.approveUser(user.id)
				.then(resp => {
					Notie.success(`Approved ${user.full_name}'s registration`);
					this.refreshTable();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to approve registration", err);
				})
				.finally(() => {
					user.approving = false;
					this.$forceUpdate();
				});
		},

		deny(user) {
			this.$set(user, "denying", true);
			PendingUserService.denyUser(user.id)
				.then(resp => {
					Notie.info(`Denied ${user.full_name}'s registration`);
					this.refreshTable();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to deny registration", err);
				})
				.finally(() => {
					user.denying = false;
					this.$forceUpdate();
				});
		},

		goToUser(pendingUser) {
			this.$set(pendingUser, "linking", true);
			UserService.getUser(pendingUser.user_id)
				.then(resp => {
					this.$router.push(`/users/${pendingUser.user_id}`);
				})
				.catch(err => {
					console.log(err);
					pendingUser.linking = false;
					Notie.error("User no longer exists");
				});
		},

		getStatus(puser) {
			if (!puser.decided) {
				return "Pending";
			} else {
				if (puser.approved) {
					return "Approved";
				} else {
					return "Denied";
				}
			}
		},

		getStatusClass(puser) {
			if (!puser.decided) {
				return "text-extra-muted";
			} else {
				if (puser.approved) {
					return "_600 text-success";
				} else {
					return "_600 text-danger";
				}
			}
		},

		listNames(objects, title) {
			if (objects && objects.length > 0) {
				let nameList = `${title}:<br /><br /><ul class='pl-4 pr-3'>`;
				_.each(objects, object => {
					nameList += `<li style="text-align: left;">${object.name}</li>`;
				});

				return nameList + "</ul>";
			} else {
				return "";
			}
		},

		refreshTable() {
			this.$refs.table.refresh();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/UserMgmt/PendingUserSetup.vue